import { render, staticRenderFns } from "./RegieCard.vue?vue&type=template&id=a5b44032&scoped=true&"
import script from "./RegieCard.vue?vue&type=script&lang=js&"
export * from "./RegieCard.vue?vue&type=script&lang=js&"
import style0 from "./RegieCard.vue?vue&type=style&index=0&id=a5b44032&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b44032",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
